import { EDIT_PROFILE, SET_PROFILE_DATA } from '../../../constants/actionTypes';

const initialState = {
  userName: '',
  picture: '',
  email: '',
};
export default function profileReducer(state = initialState, action = {}) {
  switch (action.type) {
    case EDIT_PROFILE:
      return { ...state, [action.editedProperty]: action.value };
    case SET_PROFILE_DATA:
      return { ...state, ...action.profileData };
    default:
      return state;
  }
}
